function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgRespect = function SvgRespect(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "m8.5 26.966 10.366 2.967 10.467-3.2v-.867q0-1.7-.933-2.7t-2.334-1h-3.8q0-1.4-.616-2.15a3.5 3.5 0 0 0-1.517-1.083l-8.5-3.2h-10.3v13.133H8.5zm-2.034-.1H3.333v-9.133h3.133zm20.8-1.6-8.533 2.6-10.233-3v-7.133h2.8l8.166 3.1a.97.97 0 0 1 .517.55q.15.384.15.783-1.633 0-2.383-.1a9 9 0 0 1-1.584-.366l-2.433-.8L13 22.833l2.7.833q.766.234 1.616.367t1.85.133h6.9q.4 0 .7.234.3.233.5.866",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M21.533 16.733A157 157 0 0 1 18.55 14a31 31 0 0 1-2.482-2.599q-1.065-1.265-1.7-2.448-.635-1.185-.635-2.287 0-1.725 1.174-2.896t2.904-1.17q.99 0 1.972.55a6.1 6.1 0 0 1 1.75 1.483 6.1 6.1 0 0 1 1.75-1.483q.984-.55 1.972-.55 1.73 0 2.904 1.17t1.174 2.896q0 1.103-.635 2.287-.636 1.184-1.7 2.448a31 31 0 0 1-2.488 2.604 154 154 0 0 1-2.977 2.728m4-6.733a62 62 0 0 1-4 3.966 62 62 0 0 1-4-3.966q-1.8-1.968-1.8-3.334 0-.915.578-1.49.579-.576 1.497-.576.559 0 1.108.266.551.267 1.117 1l1.5 1.834 1.5-1.834q.567-.733 1.117-1a2.5 2.5 0 0 1 1.108-.266q.917 0 1.497.576.578.575.578 1.49 0 1.366-1.8 3.334",
    clipRule: "evenodd"
  }));
};
export default SvgRespect;